const GoogleDriveIcon = () => {
  return (
    <svg
      width='28'
      height='24'
      viewBox='0 0 24 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_363_5689)'>
        <path
          d='M1.81443 18.6563L2.87285 20.4845C3.09278 20.8694 3.40893 21.1718 3.78007 21.3917L7.56014 14.8488H0C0 15.2749 0.109966 15.701 0.329897 16.0859L1.81443 18.6563Z'
          fill='#0066DA'
        />
        <path
          d='M12 7.15117L8.21993 0.608215C7.8488 0.828147 7.53265 1.13055 7.31271 1.51543L0.329897 13.6117C0.11401 13.9882 0.00028744 14.4147 0 14.8488H7.56014L12 7.15117Z'
          fill='#00AC47'
        />
        <path
          d='M20.22 21.3917C20.5911 21.1718 20.9072 20.8694 21.1272 20.4845L21.567 19.7285L23.6701 16.0859C23.8901 15.701 24 15.2749 24 14.8488H16.4393L18.0481 18.0103L20.22 21.3917Z'
          fill='#EA4335'
        />
        <path
          d='M12 7.15117L15.78 0.608217C15.4089 0.388286 14.9828 0.27832 14.5429 0.27832H9.45702C9.01716 0.27832 8.59104 0.402032 8.21991 0.608217L12 7.15117Z'
          fill='#00832D'
        />
        <path
          d='M16.4399 14.8488H7.56016L3.78009 21.3917C4.15122 21.6116 4.57734 21.7216 5.0172 21.7216H18.9828C19.4227 21.7216 19.8488 21.5979 20.22 21.3917L16.4399 14.8488Z'
          fill='#2684FC'
        />
        <path
          d='M20.1787 7.56354L16.6873 1.51543C16.4674 1.13055 16.1512 0.828147 15.7801 0.608215L12 7.15117L16.4399 14.8488H23.9863C23.9863 14.4226 23.8763 13.9965 23.6564 13.6117L20.1787 7.56354Z'
          fill='#FFBA00'
        />
      </g>
      <defs>
        <clipPath id='clip0_363_5689'>
          <rect
            width='24'
            height='21.4433'
            fill='white'
            transform='translate(0 0.27832)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default GoogleDriveIcon
